import React, { forwardRef } from 'react';
const ModalFooter = (StyledModalFooter) => forwardRef(({ children, ...props }, ref) => {
    return (<StyledModalFooter ref={ref} {...props}>
        {children}
      </StyledModalFooter>);
});
export default ModalFooter;
